import "./checkmark-card.ts";

import { Storybook } from "@tento-ui/ui/storybook";
import { Toast } from "@tento-ui/components/toast/toast";
import { CheckmarkIcon, LonaIcons } from "@tento-ui/ui/icons";
import { SheetRowCheckmarkCard } from "./checkmark-card.ts";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";

/** The storybook page for the checkmark home card, for a component gallery. */
export class SheetRowCheckmarkCardStoryBook extends Storybook.Default {
  title(): string {
    return "Sheet Row Checkmark Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Morning Workout",
            icon: LonaIcons.$template(CheckmarkIcon),
            contentBg: "var(--bg-hover-opaque)",
            $cardContent: SheetRowCheckmarkCard.makeWith({
              onToggle: (checked) => Toast.info(`Toggled: ${checked}`),
            }),
          }),
      },
      {
        title: "Raw",
        render: () =>
          SheetRowCheckmarkCard.makeWith({
            onToggle: (checked) => Toast.info(`Toggled: ${checked}`),
          }),
      },
    ];
  }
}
